import { render, staticRenderFns } from "./SectionOfCover.vue?vue&type=template&id=201cc2be&scoped=true"
import script from "./SectionOfCover.vue?vue&type=script&lang=js"
export * from "./SectionOfCover.vue?vue&type=script&lang=js"
import style0 from "./SectionOfCover.vue?vue&type=style&index=0&id=201cc2be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201cc2be",
  null
  
)

export default component.exports